<template>
<div>
   <h-header title="创建课程" btnText="创建" @btnFuc="toEditClass" :back="true"></h-header>
    <div class="create-class-box">
        <Row>
            <Col span="5">
                <span class="tit">课程名称</span>
            </Col>
            <Col span="8">
                <Input v-model="createClass.title" placeholder="请输入课程名称" />
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">开课时间</span>
            </Col>
            <Col span="8">
                <DatePicker v-model="timeValue" type="datetime" placeholder="请选择开课时间" style="width: 100%"></DatePicker>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">直播时长</span>
            </Col>
            <Col span="8">
                <InputNumber v-model="createClass.duration" :max="120" style="width:100%"></InputNumber>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">人数设置</span>
            </Col>
            <Col span="8">
                <InputNumber v-model="createClass.maxAudienceSize" style="width:100%"></InputNumber>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">展示图片</span>
            </Col>
            <Col span="8">
                <Upload class="img-box input"
                action=""
                :before-upload="handleUpload"
                >
                <Button class="img-button">
                    <div v-if="!!!createClass.img">
                        <Icon type="md-add"/>
                    </div>
                    <div v-if="!!createClass.img">
                        <img :src="splitUrl(createClass.img)">
                    </div>
                </Button>
                </Upload>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">课程选择</span>
            </Col>
            <Col span="8">
                <RadioGroup v-model="createClass.private">
                    <Radio :label="0">
                        公开课程
                    </Radio>
                    <Radio :label="1">
                        私人课程
                    </Radio>
                </RadioGroup>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">简介</span>
            </Col>
            <Col span="8">
                <Input v-model="createClass.intro"  type="textarea"/>
            </Col>
        </Row>
        <Row>
            <Col span="5">
                <span class="tit">详情</span>
            </Col>
            <Col span="19">
                <div id="wangeditor">
                    <div ref="editorElem" style="text-align:left;"></div>
                </div>
            </Col>
        </Row>
        <div class="create-btn hover" @click="toEditClass">保存</div>
    </div>

   <h-footer></h-footer>
</div>
</template>
<script>
import E from "wangeditor"
import Header from '../components/Header'
import Footer from '../components/Footer'
import QRCode from 'qrcodejs2'
export default {
    name:'AdminRoom',
    data(){
        return{
            createClass:{
                title:'',
                details:'',
                intro:'',
                img:'',
                duration:45,
                type:0,//int,直播模式0:一对多 1:一对一
                maxAudienceSize:1000,
                startTime:'',
                private:0,//int,0/公开 1/私密
            },
            timeValue:'',

            editor: null,
            editorContent: '',
        }
    },
    // catchData是一个类似回调函数，来自父组件，当然也可以自己写一个函数，主要是用来获取富文本编辑器中的html内容用来传递给服务端
    props: ['catchData'], // 接收父组件的方法
    components:{
        'h-header':Header,
        'h-footer':Footer,
    },
    created(){
       
    },
    activated(){
        if(JSON.stringify(this.$route.params) !== '{}'){
            this.createClass = this.$route.params
            this.timeValue = new Date(this.createClass.start_time*1000)
        }else{
            this.timeValue = new Date()
        }
        this.createEdit()
    },
    methods:{
        handleUpload(file,node,insert){
            let that = this
            this.$post(this,{
                'url':'getOssToken',
                'data':{
                    'uploadDir':'classroom/resource'
                },
                'success':function(reData){
                    var reData = JSON.parse(reData.token)
                    that.$postImage(that,file,reData,{
                        'success':function(data){
                            if(node !== 'edit'){
                                that.createClass.img = data
                            }else{
                                insert(that.splitUrl(data))
                            }
                        }
                    })
                }
            })
            return false
        },
        createEdit(){
            let that = this
            if(this.editor){
                this.editor.txt.clear()    
                this.editor.txt.html(this.createClass.details)
                return
            }
            this.editor = new E(this.$refs.editorElem)

            // 配置服务器端地址
            // this.editor.customConfig.uploadImgServer = 'https://hello-chinese.oss-cn-hangzhou.aliyuncs.com'

            // 编辑器的事件，每次改变会获取其html内容
            this.editor.customConfig.onchange = html => {
                this.editorContent = html
                this.createClass.details = html
                // this.catchData(this.editorContent) // 把这个html通过catchData的方法传入父组件
            };
            this.editor.customConfig.menus = [
                // 菜单配置
                'head', // 标题
                'bold', // 粗体
                'fontSize', // 字号
                'fontName', // 字体
                'italic', // 斜体
                'underline', // 下划线
                'strikeThrough', // 删除线
                'foreColor', // 文字颜色
                'backColor', // 背景颜色
                'link', // 插入链接
                'list', // 列表
                'justify', // 对齐方式
                'quote', // 引用
                'emoticon', // 表情
                'image', // 插入图片
                'table', // 表格
                'code', // 插入代码
                'undo', // 撤销
                'redo' // 重复
            ];
            this.editor.customConfig.uploadImgServer = '/upload'
            this.editor.customConfig.customUploadImg = function (files, insert) {
                // files 是 input 中选中的文件列表
                // insert 是获取图片 url 后，插入到编辑器的方法

                // 上传代码返回结果之后，将图片插入到编辑器中
                that.handleUpload(files[0],'edit',insert)
            }
            this.editor.create() // 创建富文本实例
            this.editor.txt.html(this.createClass.details)
        },
        toEditClass(){
            let that = this
            this.createClass.startTime = parseInt(new Date(this.timeValue).getTime()/1000)
            if(this.createClass.title == ''){
                this.toast('课程名不能为空')
            }else if(!this.createClass.startTime){
                this.toast('请选择开课时间')
            }else{
                this.$post(this,{
                    url:'createClass',
                    data:that.createClass,
                    success(data){
                        that.$Message['success']({
                            background: true,
                            content: '创建成功'
                        })
                        that.$store.commit('refreshClassList')
                        if(that.createClass.id){
                            that.$store.commit('refreshClassInfo')
                        }
                        that.$router.go(-1)
                    }
                })
            }
        }
    },
    destroyed(){
        this.editor = null
    }
}
</script>
<style scoped>
.create-class-box{
    width:1200px;
    margin:20px auto 0 auto;
    font-size: 18px;
    padding:27px 58px 30px;
    margin:0 auto;
}
.create-class-box .title{
    font-size: 20px;
    margin-bottom: 20px;
    color: #fff;
}
.create-class-box .tit{
    color: #fff;
}
.create-class-box .ivu-row{
    margin-bottom: 20px;
}
.create-class-box .ivu-radio-wrapper{
    font-size: 20px;
    color:#fff;
}
.create-class-box .btn{
    width:259px;
    height:40px;
    line-height: 40px;
    background:rgba(105,195,125,1);
    border-radius:20px;
    text-align: center;
    margin:0 auto;
    color: #fff;
}
.create-class-box >>> .ivu-select-dropdown{
    z-index: 99999;
}
.create-class-box .img-box{
    text-align: left;
}
.create-class-box >>> .ivu-upload-select{
    position: relative;
    width:202px;
    height:133px;
    background:rgba(220,220,220,1);
    border-radius:3px;
}
.create-class-box .ivu-upload-select img{
    position:absolute;
    width:100%;
    height: 100%;
    top: 0;
    left: 0;
}
.create-class-box .img-button{
    width:100%;
    height: 100%;
}
.create-class-box .img-button .ivu-icon-md-add{
    font-size: 40px;
}
.create-class-box .create-btn{
    width:200px;
    height:40px;
    line-height: 40px;
    color: #fff;
    background:rgba(105,195,125,1);
    border-radius:20px;
    margin:0 auto;
}

#wangeditor{
    background: #fff;
}
</style>